import React from 'react'
import './MobFooter.css'
import logo from './../../../Assets/Vector_black.png'

function MobFooter() {
    return (
        <div id='mob_footer'>
            <div className='mob_footer_logo'>
                <img src={logo} />
                <h1>SheildScan</h1>
            </div>
            <div className='mob_footer_infos'>
                <p>Privacy Policy</p>
                <p>Terms and Conditions</p>
                <p>Contact Us</p>
                <p>Careers</p>
            </div>
        </div>   
    )
}

export default MobFooter
